export const Props = () => ({
  //Дата
  date: {
    type: String,
    required: false,
  },

  //Кол-во комментариев
  commentsCount: {
    type: Number,
    required: false,
  },

  //Данные автора
  author: {
    type: Object,
    required: false,
  },

  //Cсылка на источник
  link: {
    type: String,
    required: false,
  },

  isMine: {
    type: Boolean,
    required: false,
  },

  //Начальное Кол-во комментариев
  initCommentsCount: {
    type: Number,
    required: false,
  },

  //Отображать ли Огонек
  isFire: {
    type: Boolean,
    required: false,
  },
});
